var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 2C27.5879 2 24 5.58789 24 10C24 14.4121 27.5879 18 32 18C36.4121 18 40 14.4121 40 10C40 5.58789 36.4121 2 32 2Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 62C11.3137 62 14 59.3137 14 56C14 52.6863 11.3137 50 8 50C4.68629 50 2 52.6863 2 56C2 59.3137 4.68629 62 8 62Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62C35.3137 62 38 59.3137 38 56C38 52.6863 35.3137 50 32 50C28.6863 50 26 52.6863 26 56C26 59.3137 28.6863 62 32 62Z",
    fill: "#F48000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62C59.3137 62 62 59.3137 62 56C62 52.6863 59.3137 50 56 50C52.6863 50 50 52.6863 50 56C50 59.3137 52.6863 62 56 62Z",
    fill: "#F48000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20H26C22.6914 20 20 22.6914 20 26V32C20 33.1055 20.8945 34 22 34H42C43.1055 34 44 33.1055 44 32V26C44 22.6914 41.3086 20 38 20Z",
    fill: "#F48000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 48C9.10547 48 10 47.1055 10 46V44H30V46C30 47.1055 30.8945 48 32 48C33.1055 48 34 47.1055 34 46V44H54V46C54 47.1055 54.8945 48 56 48C57.1055 48 58 47.1055 58 46V42C58 40.8945 57.1055 40 56 40H34V38C34 36.8945 33.1055 36 32 36C30.8945 36 30 36.8945 30 38V40H8C6.89453 40 6 40.8945 6 42V46C6 47.1055 6.89453 48 8 48Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIcon);
export default __webpack_public_path__ + "static/media/management_icon.3517ee8358883bd92c12a3df8756c0e5.svg";
export { ForwardRef as ReactComponent };